angular.module('zc.zenclerkS')
  .factory('ZcsAccessStats', ZcsAccessStats);

ZcsAccessStats.$inject = ['AccessStats'];
function ZcsAccessStats(AccessStats) {
  const service = {
    getLatestTotals,
    getAccessStatsForSegment,
    getPerDeviceAccessStatsForSegment,
    getAccessStatsSameSession
  };

  return service;

  function getLatestTotals(apikey) {
    return AccessStats.find({
      dimension: 'daily',
      apikey: apikey,
    }, {
      match: {
        campaign_segment_id: null,
        total_conversion_count: null,
        is_control: null,
        is_after_installed_at: null,
        device: null,
        start_at: { $gte: moment().subtract(4, 'days').toDate() }
      },
      sort: {
        start_at: -1
      },
      limit: 1
    })
      .then(res => _.last(res));
  }

  function getAccessStatsForSegment(apikey, segmentId, startAt, endAt) {
    return AccessStats.find({
      dimension: 'daily',
      apikey: apikey,
    }, {
      match: {
        campaign_segment_id: segmentId,
        total_conversion_count: null,
        is_control: null,
        is_after_installed_at: null,
        device: null,
        start_at: { $gte: startAt, $lt: endAt }
      },
      sort: {
        start_at: -1
      },
    });
  }

  function getPerDeviceAccessStatsForSegment(apikey, segmentId, startAt, endAt) {
    return AccessStats.find({
      dimension: 'daily',
      apikey: apikey,
    }, {
      match: {
        campaign_segment_id: segmentId,
        total_conversion_count: null,
        is_control: null,
        is_after_installed_at: null,
        device: { $ne: null },
        start_at: { $gte: startAt, $lt: endAt }
      },
      sort: {
        start_at: -1
      },
    });
  }

  function getAccessStatsSameSession(apikey, startAt, endAt) {
    return AccessStats.aggregate({
      dimension: 'daily',
      apikey: apikey,
    }, {
      match: {
        is_control: null,
        device: { $ne: null },
        start_at: { $gte: startAt, $lt: endAt }
      },
      pipeline: [{
        $group: {
          _id: '$start_at',
          conversion_count: { $sum: '$conversion_count' }
        }
      }, {
        $project: {
          _id: 0,
          start_at: '$_id',
          conversion_count: '$conversion_count'
        },
      }, {
        $sort: {
          start_at: 1
        }
      }]
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/access_stats.service.js